import React from "react";
import { Link } from "react-router";
import Button from "../../components/shared/button";
import { SvgPlus } from "../../components/svg";

import DarkModeToggle from "../../components/shared/darkModeToggle";
import Ripple from "../../components/Ripple";
import ContextMenuList from "../../components/ContextMenu/ContextMenuList";
import { usePopover } from "../../providers/PopoverProvider";



const DropdownContent: React.FC = () => {
  return (
    <ContextMenuList
      data-space="5"
      items={[

        { separator: true },
        { text: `Open`, bold: true, },
        { separator: true },
        { text: `Edit` },
        { text: `Share`, icon:"arrow_outward" },
        {
          element: (
            <>
              <icon data-length="30"></icon>
              <group data-gap="10" data-align="center">
              <text data-position="left">More</text>

               <icon data-opacity="light" data-length="30" >navigate_next</icon>
              </group>
            </>
          ),
        },
        { separator: true },
        { text: `Properties`, bold: true, },
        // { separator: true },
        // {
        //   customElement: ( <li data-type="inert" data-cursor="default">
        //     <group  data-align="center"  data-border="">
             
        //       <Button  large icon="cut"  />
              
        //       <Button mini large icon="drafts" />

        //     </group>
        //     </li>
        //   ),
        // },
      ]}
    />
  );
};



const ProductBrowser: React.FC = () => {

  const { open } = usePopover();
  const sampleDropdown = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    open({
      content: <DropdownContent />,
      element: e.target as HTMLElement,
    });
  };

  return (
    <view data-vertical="" data-adaptive="">
      <view data-space="30" data-scroll="" data-gap="30">
        <group data-direction="column" data-gap="15">
          <text
            data-weight="700"
            data-text-size="xxx-large"
            data-wrap="wrap"
            data-color="main"
          >
            Menus
          </text>
          <text
            data-wrap="wrap"
            data-length="300"
            data-line="20"
            data-light=""
          >
            Menus are visual displays that present a list of options or choices
            on surfaces that are temporary or can change.
          </text>
        </group>

        
        <group>
          
        <Button
            
            outline
            large
              icon="apps"
              onClick={sampleDropdown}
          >
            <text>Open Context Menu</text>
            </Button>
  
</group>
        
        <group>
          <group
            data-background="main"
            data-color="white"
          
            data-wrap="no"
            data-align="center"
            data-gap="10"
            data-radius-top="10"
            data-contain=""
          >

            <group data-direction="column" data-gap="15" data-space="30">
              <text data-weight="700" data-text-size="x-large" data-wrap="wrap">
                Sample UI Pattern
              </text>
              <text
                data-wrap="wrap"
                data-length="300"
                data-line="1.5"
                data-light=""
              >
                Some info may be visible to other people using Our services. In
                publishing and graphic design ...
              </text>
            </group>
          </group>
          <group data-background="main">
            <group>
              <nav className="nav_strip classic " data-space-horizontal="10">
                <ul>
                  <li>
                    <text data-space="10">First Item</text>
                  </li>
                  <li className="selected">
                    <text data-space="10">Sample Menu</text>
                  </li>
                </ul>
              </nav>
            </group>
          </group>

          <group
            data-elevation="1"
            data-background="main-background"
            data-radius-bottom="10"
            data-space="30"
            data-type="column"
          >
            <group>
              <div className="list_menu auto_width">
                <ul>
                  <li className="inactive">
                    <icon data-length="30"></icon>
                    <text data-color="main" data-weight="700">
                      Allert Setting
                    </text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30">star</icon>

                    <text>Quality Alerts</text>
                  </li>
                  <li className="separator"></li>
                  <li className="inactive">
                    <icon data-length="30"></icon>
                    <text data-color="main" data-weight="700">
                      Steps
                    </text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text data-weight="700">Manufacturing steps</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30" data-fill="" data-color="amber">
                      star
                    </icon>

                    <text>Work Instructions</text>
                  </li>

                  <li className="separator"></li>
                  <li className="inactive">
                    <icon data-length="30"></icon>
                    <text data-color="main" data-weight="700">
                      Operations
                    </text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text data-weight="700">Operations</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text>Control Checklist</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text>Components</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text>Label Printing</text>
                  </li>
                </ul>
              </div>
            </group>

            <group>
              <div className="list_menu auto_width">
                <ul>
                  <li className="inactive">
                    <icon data-length="30"></icon>
                    <text data-weight="700">See Also ...</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text>Safety Files</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30" data-fill="" data-color="amber">
                      star
                    </icon>

                    <text>Instruction Files</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text>Quality Files</text>
                  </li>
                  <li data-radius="5">
                    <icon data-length="30"></icon>

                    <text>Reworking scenarios</text>
                  </li>
                </ul>
              </div>
            </group>
          </group>
        </group>
      </view>

      <view>
        <view data-space="30" data-gap="20" data-scroll="">
          <group
            data-space="15"
            data-background="main-background"
            data-elevation="2"
            data-length="280"
            data-radius="10"
            data-index="2"
          >
            <div className="list_menu auto_width">
              <ul>
                <Ripple>
                  <li data-radius="5">
                    <icon data-length="30"></icon>
                    <text data-weight="700">My Account</text>
                  </li>
                </Ripple>
                <li className="separator"></li>
                <li data-radius="5">
                  <icon data-length="30"></icon>
                  <text data-position="left">Feedback</text>

                  <icon data-length="30" data-opacity="light">
                    navigate_next
                  </icon>
                </li>
                <li data-radius="5">
                  <icon data-length="30"></icon>
                  <text>Support</text>
                </li>
                <li className="separator"></li>
                <Ripple>
                  <li data-radius="5">
                    <label
                      classic="" //NOSONAR
                      data-space="10"
                    >
                      <input type="checkbox" placeholder=" " name="1" />
                      <box>
                        <check></check>
                      </box>
                      <text>Sample Checkbox</text>
                    </label>
                  </li>
                </Ripple>

                <li className="separator"></li>

                <li
                  data-type="inert"
                  data-radius="5"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <DarkModeToggle />
                </li>

                <li className="separator"></li>
                <li data-radius="5">
                  <icon data-length="30"></icon>
                  <group data-gap="10" data-align="center">
                    <text>Version</text>
                    <separator
                      data-vertical="dotted"
                      data-height="20"
                    ></separator>
                    <text
                      light="" //NOSONAR
                    >
                      2.0.0
                    </text>
                  </group>
                </li>
                <li data-radius="5">
                  <icon data-length="30"></icon>
                  <text data-weight="700">Sign Out</text>
                </li>
              </ul>
            </div>
          </group>

          <group data-index="1">
            <div className="nav_tree_cont">
              <div className="nav_tree_menu">
                <div className="nav_tree_menu_wrap">
                  <div className="list_menu auto_width">
                    <ul>
                      <li className="selected">
                        <label>
                          <Link to="">
                            <text>Heating Emitters</text>
                          </Link>
                          <Button mini large  toggleClassName="open">
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Climatisation</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Heat Pump</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Stoves</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Hot Water</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Ventilation</text>
                          </Link>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="nav_tree_menu">
                <div className="nav_tree_menu_wrap">
                  <div className="list_menu auto_width">
                    <ul>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Electric Heating</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li>
                        <label>
                          <Link to="">
                            <text>Hot Water (Towel Dryer)</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Fan Coil Radiators</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                      <li data-radius="5">
                        <label>
                          <Link to="">
                            <text>Heating And Cooling Ceiling</text>
                          </Link>
                          <Button mini large toggleClassName="open" material>
                            <icon data-opacity="light">
                              <SvgPlus />
                            </icon>
                          </Button>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </group>
        </view>
      </view>
    </view>
  );
};
export default ProductBrowser;
